<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Planes</h4>
    <hr />

    <DataTable
      :data="plans"
      :columns="[
        { label: 'Nombre',          field: 'nombre' },
        { label: 'Descripción',     field: 'descripcion' },
        { label: 'Precio',          field: 'precio',     format: v => Number(v).toFixed(2) },
        { label: 'Núm. Máx. Usr.',  field: 'numMaxUsr' },
        { label: 'Fecha Registro',  field: 'fechaReg',   format: v => getFormattedDate(v) },
      ]"
      idField="idPlan"
      mensajeVacio="No hay registros de planes."
      @refresh="getDataPaginaTodos"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idPlan)"
      @view="row => abrirEditar(row.idPlan)"
      @delete="row => deletePlan(row.idPlan)"
    />

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">{{ titulo }}</h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <!-- ID solo en edición -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">ID</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPlan.idPlan" disabled />
                </div>
              </div>
            </div>
            <!-- Nombre -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Nombre</label></div>
                <div class="col-10">
                  <input
                    type="text"
                    class="form-control"
                    v-model="datoPlan.nombre"
                    style="text-transform:uppercase"
                  />
                </div>
              </div>
            </div>
            <!-- Descripción -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Descripción</label></div>
                <div class="col-10">
                  <textarea
                    class="form-control"
                    v-model="datoPlan.descripcion"
                    style="text-transform:uppercase"
                    rows="3"
                  ></textarea>
                </div>
              </div>
            </div>
            <!-- Precio / Núm. Máx. Usuarios -->
            <div class="mb-3">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Precio</label></div>
                <div class="col-4">
                  <input
                    type="number"
                    step="0.01"
                    class="form-control"
                    v-model="datoPlan.precio"
                  />
                </div>
                <div class="col-2"><label class="form-label fw-bold">Núm. Máx. Usr.</label></div>
                <div class="col-4">
                  <input
                    type="number"
                    class="form-control"
                    v-model="datoPlan.numMaxUsr"
                  />
                </div>
              </div>
            </div>
            <!-- Fecha registro (solo edición) -->
            <div class="mb-3" v-if="btnEditar">
              <div class="row">
                <div class="col-2"><label class="form-label fw-bold">Fecha Registro</label></div>
                <div class="col-10">
                  <input type="text" class="form-control" v-model="datoPlan.fechaReg" disabled />
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarPlan"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarPlan"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import dateFormat      from "@/modules/dateFormat.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  components: { Layout, Footer, DataTable },
  data() {
    return {
      plans:       [],
      datoPlan:    {},
      titulo:      "",
      btnCrear:    false,
      btnEditar:   false,
      modalWindow: true,
    };
  },
  mounted() {
    this.getDataPaginaTodos();
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
  },
  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },
    getDataPaginaTodos() {
      api.get("/vwplans")
        .then(r => { this.plans = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar planes:", e));
    },
    validarForm() {
      return validarForm(
        this.datoPlan,
        ["nombre", "descripcion", "precio"],
        ["nombre", "descripcion", "precio"]
      );
    },
    async guardarPlan() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/plans", this.datoPlan);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Plan creado exitosamente." });
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },
    async actualizarPlan() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/plans", this.datoPlan);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Plan actualizado exitosamente." });
        this.getDataPaginaTodos();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },
    async deletePlan(idPlan) {
      const confirm = await Swal.fire({
        title: "¿Eliminar plan?",
        text: "Esta acción no se puede deshacer.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/plans/" + idPlan);
        this.getDataPaginaTodos();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },
    abrirModalCrear() {
      this.modalWindow = true;
      this.datoPlan    = {};
      this.titulo      = "Crear Plan";
      this.btnCrear    = true;
      this.btnEditar   = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },
    async abrirModalEditar(idPlan) {
      this.modalWindow = true;
      this.titulo      = "Editar Plan";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp    = await api.get("/vwplans/" + idPlan);
        this.datoPlan = resp.data;
      } catch (e) {
        console.error("Error al cargar plan:", e);
        return;
      }
      $("#ventanaModal").modal("show");
    },
    abrirEditar(idPlan) {
      if (idPlan != null) this.$router.push("/planmd/" + idPlan);
    },
  },
};
</script>